var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import Uploader from './uploader.vue';
import ShopAfterSalesService from "../../../api/ShopAfterSalesService";
import HeaderItem from '../../../components/HeaderItem';
var AddHeader = (function (_super) {
    __extends(AddHeader, _super);
    function AddHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.purchaseOrderOrderDetail = {
            business_id: 0,
            business_name: '',
            business_phone: '',
            order_code: '',
            order_id: 0,
            shop_id: 0,
            shop_name: '',
            supplier_to_business_id: 0,
            purchase_order_order_code: '',
        };
        _this.PurchaseOrderOrderIdOptions = [];
        _this.loading = false;
        _this.imageUrlList = [];
        _this.orderTypeOptions = [
            {
                label: '退货退款',
                value: 1,
            },
            {
                label: '仅退款',
                value: 3,
            },
        ];
        _this.refundReasonOptions = [
            {
                label: '其它',
                value: '其它',
            },
            {
                label: '质量原因',
                value: '质量原因',
            },
        ];
        return _this;
    }
    AddHeader.prototype.created = function () {
        this.service = ShopAfterSalesService.getInstance();
        if (this.formData.edit === false) {
            this.editAfterSalesOrderDetail();
        }
        console.log('keyword', this.formData.keyword);
        if (this.formData.keyword) {
            this.purchaseOrderOrderMethod(this.formData.keyword, true);
        }
    };
    AddHeader.prototype.purchaseOrderOrderMethod = function (query, auto) {
        var _this = this;
        if (auto === void 0) { auto = false; }
        if (query) {
            this.loading = true;
            var params = {
                keyword: query,
                page: 1,
                page_size: 10,
            };
            this.service.getRefundPurchaseOrderOrderList(params).then(function (res) {
                _this.loading = false;
                _this.PurchaseOrderOrderIdOptions = res.data.data || [];
                if (auto) {
                    _this.formData.purchase_order_order_id = _this.PurchaseOrderOrderIdOptions[0].order_id;
                    _this.handleOrderTypeChange();
                    console.log('auth====', _this.formData.purchase_order_order_id);
                }
            });
        }
        else {
            this.PurchaseOrderOrderIdOptions = [];
        }
    };
    AddHeader.prototype.handleOrderTypeChange = function () {
        var _this = this;
        this.purchaseOrderOrderDetail = this.PurchaseOrderOrderIdOptions.find(function (item) {
            return item.order_id === _this.formData.purchase_order_order_id;
        });
        this.formData.purchase_order_order_code = this.purchaseOrderOrderDetail.order_code;
        this.formData.business_id = this.purchaseOrderOrderDetail.business_id;
        this.formData.business_name = this.purchaseOrderOrderDetail.business_name;
        this.formData.supplier_to_business_id = this.purchaseOrderOrderDetail.supplier_to_business_id;
        this.formData.shop_id = this.purchaseOrderOrderDetail.shop_id;
        this.formData.shop_name = this.purchaseOrderOrderDetail.shop_name;
        this.formData.creator_name = this.purchaseOrderOrderDetail.business_phone;
        this.formData.goods_list = [];
        this.$emit('emptyData');
    };
    AddHeader.prototype.editAfterSalesOrderDetail = function () {
        var _this = this;
        setTimeout(function () {
            _this.purchaseOrderOrderDetail.business_id = _this.formData.business_id;
            _this.purchaseOrderOrderDetail.business_name = _this.formData.business_name;
            _this.purchaseOrderOrderDetail.supplier_to_business_id = _this.formData.supplier_to_business_id;
            _this.purchaseOrderOrderDetail.shop_id = _this.formData.shop_id;
            _this.purchaseOrderOrderDetail.shop_name = _this.formData.shop_name;
            _this.purchaseOrderOrderDetail.business_phone = _this.formData.creator_name;
            console.log(1234, _this.purchaseOrderOrderDetail.business_phone);
            _this.imageUrlList = _this.formData.images;
            _this.$forceUpdate();
        }, 500);
    };
    __decorate([
        Prop({
            required: true,
        })
    ], AddHeader.prototype, "formData", void 0);
    AddHeader = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
                uploader: Uploader,
            },
        })
    ], AddHeader);
    return AddHeader;
}(Vue));
export default AddHeader;
